import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { exchangeSession } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/"); return; }
    const session_id = decodeURIComponent(m[1]);
    (async () => {
      try {
        let ref = null;
        try { ref = window.localStorage.getItem("mythos_ref"); } catch (e) { /* ignore */ }
        const user = await exchangeSession(session_id, ref);
        try { window.localStorage.removeItem("mythos_ref"); } catch (e) { /* ignore */ }
        setUser(user);
        window.history.replaceState({}, "", "/dashboard");
        nav("/dashboard", { replace: true, state: { user } });
      } catch (e) {
        nav("/", { replace: true });
      }
    })();
  }, [location.hash, nav, setUser]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-slate-400 font-mono text-sm uppercase tracking-widest">Signing you in…</div>
    </div>
  );
}
